export const _setBookedSessionPagination = (state, action) => {
  state.bookedSessionPagination = [
    ...state.bookedSessionPagination,
    action.payload,
  ];
};

export const _setBookedSessionPaginationPreviousKey = (state, action) => {
  state.bookedSessionPaginationPreviousKey = action.payload;
};
